import { keysToCamelCase } from '@wix/wix-vod-shared/common';
import { TransportError } from './transport-error';
export function toError(error) {
    const errorResponse = error.response;
    const { status, statusText: message, data = {} } = errorResponse;
    const url = error.config?.url;
    const camelCasedData = keysToCamelCase(data);
    const { errorCode, errorDescription } = camelCasedData;
    return Promise.reject(new TransportError(status, url, {
        code: errorCode,
        data: camelCasedData,
        message: errorDescription || message,
    }));
}
//# sourceMappingURL=to-error.js.map